import loadJsonData from 'Components/Lib/Utils/loadJsonData';
import URLS from 'Components/Lib/Utils/URLs.API';
import MFXLocalStorage from 'Helpers/MFXLocalStorage';
import React, { createContext, useContext, useEffect, useState } from 'react';

const SettingsContext = createContext(null);

export const useSettings = () => useContext(SettingsContext) as any;

export const SettingsProvider = ({ children }) => {
    const [systemSettings, setSystemSettings] = useState(null);

    useEffect(() => {
        if(!MFXLocalStorage?.getConnectionKey()) return;
        loadJsonData('/' + MFXLocalStorage?.getConnectionKey() + URLS.GetSystemSettings).then((settings: any) => {
            if (settings.Meta.Success && settings.Data) {
                setSystemSettings(settings.Data);
            }
        });
    }, []);
    return <SettingsContext.Provider value={{ systemSettings } as any}>{children}</SettingsContext.Provider>;
};
